<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
import msalInstance from './auth/msalInstance'
import { loginRequest } from './auth/msalConfig'

export default {
  name: 'App',
  async created() {
    try {
      await msalInstance.initialize()

      let response = null
      try {
        response = await msalInstance.handleRedirectPromise()
      } catch (e) {
        console.error('handleRedirectPromise failed:', e)
        this.$store.commit('SET_AUTH_ERROR', `Token exchange failed: ${e.message}`)
        return
      }

      if (response) {
        await this.$store.dispatch('loginSuccess', response)
        if (this.$store.getters.isAuthenticated) {
          this.$router.push('/regattas')
        }
      } else {
        const accounts = msalInstance.getAllAccounts()
        if (accounts.length > 0) {
          try {
            const silent = await msalInstance.acquireTokenSilent({
              ...loginRequest,
              account: accounts[0],
            })
            await this.$store.dispatch('loginSuccess', silent)
            if (this.$store.getters.isAuthenticated && this.$route.path === '/login') {
              this.$router.push('/regattas')
            }
          } catch (e) {
            await msalInstance.clearCache()
          }
        }
      }
    } catch (e) {
      console.error('MSAL init error:', e)
      this.$store.commit('SET_AUTH_ERROR', `MSAL initialisation failed: ${e.message}`)
    }
  }
}
</script>

<style>
:root {
  background-color: #333333;
}
</style>
